import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/home/runner/work/ibm-aiops-training/ibm-aiops-training/node_modules/gatsby-theme-carbon/src/templates/Default.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h2>{`🚀 TASK: Open the DemoUI`}</h2>
    <ol>
      <li parentName="ol">
        <p parentName="li">{`In your OpenShift Console click on the Applications Menu`}</p>
        <img parentName="li" {...{
          "src": "./../images/07_fzth_ocp_menu.png",
          "alt": "image"
        }}></img>
      </li>
      <li parentName="ol">
        <p parentName="li">{`Select `}<strong parentName="p">{`CP4AIOps Demo UI`}</strong></p>
      </li>
      <li parentName="ol">
        <p parentName="li">{`Login with token `}<inlineCode parentName="p">{`P4ssw0rd!`}</inlineCode></p>
        <img parentName="li" {...{
          "src": "./../images/08_demo_ui_login.png",
          "alt": "image"
        }}></img>
      </li>
      <li parentName="ol">
        <p parentName="li">{`Copy the Admin Password`}</p>
        <img parentName="li" {...{
          "src": "./../images/09_demo_ui_aimanager_pwd.png",
          "alt": "image"
        }}></img>
      </li>
      <li parentName="ol">
        <p parentName="li">{`Open `}<inlineCode parentName="p">{`CP4AIOPS`}</inlineCode></p>
        <img parentName="li" {...{
          "src": "./../images/10_demo_ui_aimanager_open.png",
          "alt": "image"
        }}></img>
      </li>
    </ol>
    <h2>{`🚀 TASK: Login to CP4AIOPS`}</h2>
    <ol>
      <li parentName="ol">
        <p parentName="li">{`Select `}<inlineCode parentName="p">{`IBM provided credentials`}</inlineCode></p>
        <img parentName="li" {...{
          "src": "./../images/11_demo_ui_aimanager_type.png",
          "alt": "image"
        }}></img>
      </li>
      <li parentName="ol">
        <p parentName="li">{`Login with `}<inlineCode parentName="p">{`admin`}</inlineCode>{` user and the password you copied in the step above`}</p>
        <img parentName="li" {...{
          "src": "./../images/12_demo_ui_aimanager_login.png",
          "alt": "image"
        }}></img>
      </li>
      <li parentName="ol">
        <p parentName="li">{`Welcome to  `}<inlineCode parentName="p">{`CP4AIOPS`}</inlineCode></p>
        <img parentName="li" {...{
          "src": "./../images/13_demo_ui_aimanager_welcome.png",
          "alt": "image"
        }}></img>
      </li>
    </ol>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      